const actions = {
  TASK_ADD_BEGIN: 'TASK_ADD_BEGIN',
  TASK_ADD_SUCCESS: 'TASK_ADD_SUCCESS',
  TASK_ADD_ERR: 'TASK_ADD_ERR',

  TASK_READ_BEGIN: 'TASK_READ_BEGIN',
  TASK_READ_SUCCESS: 'TASK_READ_SUCCESS',
  TASK_READ_ERR: 'TASK_READ_ERR',

  GET_TASKS_BY_USER_READ_BEGIN: 'GET_TASKS_BY_USER_READ_BEGIN',
  GET_TASKS_BY_USER_READ_SUCCESS: 'GET_TASKS_BY_USER_READ_SUCCESS',
  GET_TASKS_BY_USER_READ_ERR: 'GET_TASKS_BY_USER_READ_ERR',

  SINGLE_TASK_READ_BEGIN: 'SINGLE_TASK_READ_BEGIN',
  SINGLE_TASK_READ_SUCCESS: 'SINGLE_TASK_READ_SUCCESS',
  SINGLE_TASK_READ_ERR: 'SINGLE_TASK_READ_ERR',

  ASSIGNED_TASKS_READ_BEGIN: 'ASSIGNED_TASKS_READ_BEGIN',
  ASSIGNED_TASKS_READ_SUCCESS: 'ASSIGNED_TASKS_READ_SUCCESS',
  ASSIGNED_TASKS_READ_ERR: 'ASSIGNED_TASKS_READ_ERR',

  ASSIGNED_TASK_TO_PERSON_BEGIN: 'ASSIGNED_TASK_TO_PERSON_BEGIN',
  ASSIGNED_TASK_TO_PERSON_SUCCESS: 'ASSIGNED_TASK_TO_PERSON_SUCCESS',
  ASSIGNED_TASK_TO_PERSON_ERR: 'ASSIGNED_TASK_TO_PERSON_ERR',

  TASK_UPDATE_BEGIN: 'TASK_UPDATE_BEGIN',
  TASK_UPDATE_SUCCESS: 'TASK_UPDATE_SUCCESS',
  TASK_UPDATE_ERR: 'TASK_UPDATE_ERR',

  TASKINFO_READ_BEGIN: 'TASKINFO_READ_BEGIN',
  TASKINFO_READ_SUCCESS: 'TASKINFO_READ_SUCCESS',
  TASKINFO_READ_ERR: 'TASKINFO_READ_ERR',

  getTaskByUserReadBegin: () => {
    return {
      type: actions.GET_TASKS_BY_USER_READ_BEGIN,
    };
  },

  getTaskByUserReadSuccess: (data) => {
    return {
      type: actions.GET_TASKS_BY_USER_READ_SUCCESS,
      data,
    };
  },

  getTaskByUserReadErr: (err) => {
    return {
      type: actions.GET_TASKS_BY_USER_READ_ERR,
      err,
    };
  },

  assignTaskToPersonBegin: () => {
    return {
      type: actions.ASSIGNED_TASK_TO_PERSON_BEGIN,
    };
  },

  assignTaskToPersonSuccess: (data) => {
    return {
      type: actions.ASSIGNED_TASK_TO_PERSON_SUCCESS,
      data,
    };
  },

  assignTaskToPersonErr: (err) => {
    return {
      type: actions.ASSIGNED_TASK_TO_PERSON_ERR,
      err,
    };
  },

  taskAddBegin: () => {
    return {
      type: actions.TASK_ADD_BEGIN,
    };
  },

  taskAddSuccess: (data) => {
    return {
      type: actions.TASK_ADD_SUCCESS,
      data,
    };
  },

  taskAddErr: (err) => {
    return {
      type: actions.TASK_ADD_ERR,
      err,
    };
  },

  taskReadBegin: () => {
    return {
      type: actions.TASK_READ_BEGIN,
    };
  },

  taskReadSuccess: (data) => {
    return {
      type: actions.TASK_READ_SUCCESS,
      data,
    };
  },

  taskReadErr: (err) => {
    return {
      type: actions.TASK_READ_ERR,
      err,
    };
  },


  taskInfoReadBegin: () => {
    return {
      type: actions.TASKINFO_READ_BEGIN,
    };
  },

  taskInfoReadSuccess: (data) => {
    return {
      type: actions.TASKINFO_READ_SUCCESS,
      data,
    };
  },

  taskInfoReadErr: (err) => {
    return {
      type: actions.TASKINFO_READ_ERR,
      err,
    };
  },

  singleTaskReadBegin: () => {
    return {
      type: actions.SINGLE_TASK_READ_BEGIN,
    };
  },

  singleTaskReadSuccess: (data) => {
    return {
      type: actions.SINGLE_TASK_READ_SUCCESS,
      data,
    };
  },

  singleTaskReadErr: (err) => {
    return {
      type: actions.SINGLE_TASK_READ_ERR,
      err,
    };
  },

  assignedTasksReadBegin: () => {
    return {
      type: actions.ASSIGNED_TASKS_READ_BEGIN,
    };
  },

  assignedTasksReadSuccess: (data) => {
    return {
      type: actions.ASSIGNED_TASKS_READ_SUCCESS,
      data,
    };
  },

  assignedTasksReadErr: (err) => {
    return {
      type: actions.ASSIGNED_TASKS_READ_ERR,
      err,
    };
  },

  taskUpdateBegin: () => {
    return {
      type: actions.TASK_UPDATE_BEGIN,
    };
  },

  taskUpdateSuccess: (data) => {
    return {
      type: actions.TASK_UPDATE_SUCCESS,
      data,
    };
  },

  taskUpdateErr: (err) => {
    return {
      type: actions.TASK_UPDATE_ERR,
      err,
    };
  },

};

export default actions;
